import { practiceAreas } from '@/data/practiceAreas';
import PracticeAreaTemplate from '@/components/PracticeAreaTemplate';

export default function WillsAndTrustsPage() {
  return <PracticeAreaTemplate practiceArea={practiceAreas['wills-and-trusts']} />;
}
